import type { Faq } from '../types/content';

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Diesel technicians, mechanics, apprentices and workshop owners who want a structured, visual way to approach diesel faults — from the first symptom to the verified cause.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. Diesel Diagnostic Pro™ is a digital product: six diagnostic modules and five bonus resources you can view on screen or print for the workshop.',
  },
  {
    question: 'Is this a training course or certification?',
    answer:
      'No. It is a visual reference and workflow system for daily diagnostic work. It does not include a course, exams or any certification.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. The modules are built around diagrams, numbered test sequences, decision trees, compact tables and case sheets rather than long paragraphs of theory.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Diagnostic foundations and workflow; fuel system and common rail; air intake, turbo and boost; electrical, sensors and actuators; EGR, DPF, SCR and emissions; and advanced faults with real-world cases.',
  },
  {
    question: 'Does this replace professional procedures or manufacturer instructions?',
    answer:
      'No. It is reference material to help you organize your diagnosis. Specifications, values, connector views and test procedures must always be confirmed in the manufacturer’s service information for the specific vehicle or engine.',
  },
  {
    question: 'How will I receive it?',
    answer: '',
    pendingKey: 'deliveryDetails',
  },
  {
    question: 'Does it work for light-duty, heavy-duty and agricultural diesel engines?',
    answer:
      'The diagnostic logic — symptom, evidence, test, decision, verification — applies across many diesel applications. It is not a model-specific manual and does not claim universal compatibility; always check the documentation for the engine you are working on.',
  },
  {
    question: 'Do I need a specific scan tool or expensive equipment to use it?',
    answer:
      'No specific brand is required. The workflows refer to common workshop tools such as a scan tool and a multimeter; the exact equipment needed depends on the test and the manufacturer’s procedure.',
  },
  {
    question: 'Is it a one-time payment, and how does the refund work?',
    answer: '',
    pendingKey: 'paymentTerms',
  },
];
